import { observable, action } from "mobx";
import { ApiService, ApiUrl } from "../helpers";
import Alert from 'react-s-alert';

const lookupStore = observable(
  {
    customFields: [],
    currentWorkTypes: [],
    countries: [],
    skillCategories: [],
    skillSubCategories: [],
    skills: [],
    publicCompanies: [],
    candidateStatuses: [],
    clientStatuses: [],
    salutations: [],

    setCandidateStatuses(candidateStatuses) {
      this.candidateStatuses = [...candidateStatuses];
    },

    setClientStatuses(clientStatuses) {
      this.clientStatuses = [...clientStatuses];
    },

    setSalutations(salutations) {
      this.salutations = [...salutations];
    },

    setCountries(countries) {
      this.countries = [...countries];
    },

    setCustomFields(customFields) {
      this.customFields = [...customFields];
    },

    setCurrentWorkTypes(currentWorkTypes) {
      this.currentWorkTypes = [...currentWorkTypes];
    },

    // #region Skills setters
    setSkillCategories(skillCategories) {
      this.skillCategories = [...skillCategories];
    },

    setSkillSubCategories(skillSubCategories) {
      this.skillSubCategories = [...skillSubCategories];
    },

    setSkills(skills) {
      this.skills = [...skills];
    },

    setPublicCompanies(publicCompanies) {
      this.publicCompanies = [...publicCompanies];
    },
    // #endregion

    getCustomFieldsPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getCustomFieldsPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCustomFields(response.data.result);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCountriesPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getJACountriesPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCountries(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCurrentWorkTypesPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getJAWorkTypesPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API
              this.setCurrentWorkTypes(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCandidateStatusesPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getJACandidateStatusesPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCandidateStatuses(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getClientStatusesPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getJAClientStatusesPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setClientStatuses(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getSalutationsPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getJASalutationsPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setSalutations(response.data.result.items || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    // #region Skills fetchers
    getSkillCategoriesPublic: (token, type) => ApiService.getDetailWithParams(ApiUrl.getSkillCategoriesPublic, '', { token, type }).then(
      action(response => {
        if (response && response.status === 200 && response.data && !response.data.isError) {
          lookupStore.setSkillCategories(response.data);
        } else {
          Alert.error("Oops, Something went wrong! Please try again.");
        }

        return Promise.resolve(response.data);
      })
    ).catch(
      action(err => Promise.reject(err))
    ),

    getSkillSubCategoriesPublic: (token, type) => ApiService.getDetailWithParams(ApiUrl.getSkillSubCategoriesPublic, '', { token, type }).then(
      action(response => {
        if (response && response.status === 200 && response.data && !response.data.isError) {
          lookupStore.setSkillSubCategories(response.data);
        } else {
          Alert.error("Oops, Something went wrong! Please try again.");
        }

        return Promise.resolve(response.data);
      })
    ).catch(
      action(err => Promise.reject(err))
    ),

    getSkillsPublic: (token, type) => ApiService.getDetailWithParams(ApiUrl.getSkillsPublic, '', { token, type }).then(
      action(response => {
        if (response && response.status === 200 && response.data && !response.data.isError) {
          lookupStore.setSkills(response.data);
        } else {
          Alert.error("Oops, Something went wrong! Please try again.");
        }

        return Promise.resolve(response.data);
      })
    ).catch(
      action(err => Promise.reject(err))
    ),

    getPublicCompanies: (token, type) => ApiService.getDetailWithParams(ApiUrl.getJACompaniesPublic, '', { token, type }).then(
      action(response => {
        if (response && response.status === 200 && response.data && !response.data.isError) {
          lookupStore.setPublicCompanies(response.data.result);
        } else {
          Alert.error("Oops, Something went wrong! Please try again.");
        }

        return Promise.resolve(response.data);
      })
    ).catch(
      action(err => Promise.reject(err))
    ),
    // #endregion
  }
);

export default lookupStore;
